import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'firstcase',
})
export class FirstLetterPipe implements PipeTransform {
  transform(value: string, ...args: any[]): any {
    if (!value) { return ''; }
    const res = value.toLowerCase();
    return res.charAt(0).toUpperCase() + res.substring(1);
  }
}
